import { useEffect, useMemo } from "react";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import StepAccordion from "./StepAccordion";
import { useDashboardUIContext } from "@contexts/dashboardUI";
import TableItem from "./TableItem";
import ProjectionLoadState from "../ProjectionLoadState";

const CellAccordion = ({ parent }) => {

  const { barChartDate } = useDashboardUIContext()
  const { activeProject: { _id, cells = {} }, filterDates } = useProjectContext();
  const { loadCells } = useProjectActions();

  useEffect(() => {
    if (_id) {
      loadCells(parent, barChartDate);
    }
  }, [_id, filterDates, barChartDate])

  const unitCells = useMemo(() => cells[parent], [cells, parent])

  return (
    <>
      <ProjectionLoadState
        level="cells"
        parent={parent}
        isMissing={!unitCells}
        onRetry={() => loadCells(parent, barChartDate)}
      />
      {unitCells?.map((item, index) => <TableItem key={index} item={item} type={"cell"} typeTitle={"Célula construtiva"} ChildAccordionComponent={StepAccordion} />)}
    </>
  )
}

export default CellAccordion;
